import { z } from 'zod';
import { IsoDateTimeSchema, OrganisationRoleSchema } from './common.js';
const SLUG_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;
export const CreateOrganisationRequestSchema = z.object({
    name: z.string().min(1).max(200),
    slug: z.string().min(1).max(63).regex(SLUG_PATTERN, 'lowercase letters, numbers, hyphens only'),
});
export const UpdateOrganisationRequestSchema = z.object({
    name: z.string().min(1).max(200),
});
export const OrganisationSchema = z.object({
    id: z.string().min(1),
    name: z.string().min(1),
    slug: z.string().min(1),
    createdAt: IsoDateTimeSchema,
});
export const OrganisationMembershipSchema = OrganisationSchema.extend({
    role: OrganisationRoleSchema,
    /** Displays (screens) in this tenant — for the Admin switcher. */
    displayCount: z.number().int().nonnegative(),
    /** Displays with a heartbeat inside the online window. */
    onlineDisplayCount: z.number().int().nonnegative(),
    /** Paired displays that have reported before but are past the online window. */
    offlineDisplayCount: z.number().int().nonnegative(),
    locationCount: z.number().int().nonnegative(),
});
export const OrganisationMemberSchema = z.object({
    userId: z.string().min(1),
    email: z.string().email(),
    displayName: z.string().nullable(),
    role: OrganisationRoleSchema,
    createdAt: IsoDateTimeSchema,
});
//# sourceMappingURL=organisation.js.map